import React from "react"
import ContactForm from "../components/contact-form"
import ReactMarkdown from "react-markdown"

function FormDivider(props) {
  console.log(props)
  return (
    <div className="home-contact-container">
      <div className="home-contact">
        <div>
          <h1>{props.title}</h1>
          <ReactMarkdown source={props.content} />
        </div>
        <div>
          <ContactForm />
        </div>
      </div>
    </div>
  )
}

export default FormDivider
